export default __webpack_public_path__ + "static/media/darkPurpleCloudFormation.6a09c6b8.svg";